module.exports = __webpack_public_path__ + "assets/images/default-bc96189d88bb4e73034aaa48cfbffa63.jpg";